import { getCanViewLuxPlusBenefits, getIsLuxPlusLPPEnabled } from 'luxPlus/selectors/featureToggle'
import { useAppSelector } from 'hooks/reduxHooks'
import getValueOffPercent from 'lib/offer/getValueOffPercent'

export default function useBedbankDiscount(discount = 0, memberDiscount = 0): number {
  const canViewLuxPlusBenefits = useAppSelector(getCanViewLuxPlusBenefits)
  const luxPlusLPPEnabled = useAppSelector(getIsLuxPlusLPPEnabled)

  if ((memberDiscount ?? 0) > 0 && canViewLuxPlusBenefits && luxPlusLPPEnabled) {
    return memberDiscount
  }

  return discount
}

export function useBedbankDiscountFromPriceAndValue(value: number, price: number, memberPrice = 0): number {
  const canViewLuxPlusBenefits = useAppSelector(getCanViewLuxPlusBenefits)
  const luxPlusLPPEnabled = useAppSelector(getIsLuxPlusLPPEnabled)

  if ((memberPrice ?? 0) > 0 && canViewLuxPlusBenefits && luxPlusLPPEnabled) {
    return getValueOffPercent(value, memberPrice)
  }

  return getValueOffPercent(value, price)
}
